import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';

const INITIAL_STATE = fromJS({
  stores: fromJS([]),
  suggestions: fromJS([]),
  cities: fromJS([]),
  citiesSuggestions: fromJS([]),
  fetching: false,
  patchingCollection: false,
  patchingCollectionMessage: null,
});

function getStores(state, action) {
  return state
    .set('fetching', true)
}

function getStoresSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('stores', fromJS(action.payload.body))
}

function getStoresFailed(state, action) {
  return state
    .set('fetching', false)
}

function resetState(state, action) {
  return INITIAL_STATE;
}

function getStoresSuggestions(state, action) {
  return state;
}

function getStoresSuggestionsSuccess(state, action) {
  return state
    .set('suggestions', fromJS(action.payload.body))
}

function getStoresSuggestionsFailed(state, action) {
  return state;
}

function changeStoresState(state, action) {
  return state
    .set(action.payload.key, fromJS(action.payload.value))
}

function getCities(state, action) {
  return state;
}

function getCitiesSuccess(state, action) {
  return state
    .set('cities', fromJS(action.payload.body))
}

function getCitiesFailed(state, action) {
  return state;
}

function updateStoresCollection(state, action) {
  return state
    .set("patchingCollection", true);
}

function updateStoresCollectionSuccess(state, action) {
  return state
    .set("patchingCollection", false);
}

function updateStoresCollectionFailed(state, action) {
  let error  = null;
  try {
    error = action.payload.response.body.error.message
  } catch (e) {
    error = "Failed to update"
  }
  return state
    .set("patchingCollection", false)
    .set("patchingCollectionMessage", error);
}


export const stores = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_STORES]: getStores,
  [ActionTypes.GET_STORES_SUCCESS]: getStoresSuccess,
  [ActionTypes.GET_STORES_FAILED]: getStoresFailed,
  '@@router/LOCATION_CHANGE': resetState,
  [ActionTypes.LOG_OUT]: resetState,
  [ActionTypes.GET_STORES_SUGGESTIONS]: getStoresSuggestions,
  [ActionTypes.GET_STORES_SUGGESTIONS_SUCCESS]: getStoresSuggestionsSuccess,
  [ActionTypes.GET_STORES_SUGGESTIONS_FAILED]: getStoresSuggestionsFailed,
  [ActionTypes.CHANGE_STORES_STATE]: changeStoresState,
  [ActionTypes.GET_CITIES]: getCities,
  [ActionTypes.GET_CITIES_SUCCESS]: getCitiesSuccess,
  [ActionTypes.GET_CITIES_FAILED]: getCitiesFailed,
  [ActionTypes.UPDATE_STORES_COLLECTION]: updateStoresCollection,
  [ActionTypes.UPDATE_STORES_COLLECTION_SUCCESS]: updateStoresCollectionSuccess,
  [ActionTypes.UPDATE_STORES_COLLECTION_FAILED]: updateStoresCollectionFailed,
});



// WEBPACK FOOTER //
// ./src/reducers/stores.js